import { render, staticRenderFns } from "./ComplexEdit.vue?vue&type=template&id=6807d058&"
import script from "./ComplexEdit.vue?vue&type=script&lang=js&"
export * from "./ComplexEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports